// Module
var code = `<div class="alert">
  <span>
    <strong>DISCLAIMER:</strong> This form can be used to process backdated GL transactions for selected branch.
  </span>
</div>
<div class="alert alert--danger">
  This process may interfere with ongoing branch operations so make sure that it's executed after counter is closed and no other user is posting transactions for this particular branch.
</div>

<h2 class="section-header">Please confirm the following:</h2>
<form name="form">
  <table class="table">
    <tbody>
    <tr>
      <td>Branch:</td>
      <td>
        <select
          ng-model="\$ctrl.branch"
          ng-options="branch as branch.name | prettyEnum for branch in \$ctrl.branches | orderBy:'name'"
          required>
        </select>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="flex-end">
    <button
      type="submit"
      class="btn btn-success"
      ng-disabled="form.\$invalid"
      ng-click="\$ctrl.execute()">
      Execute
    </button>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/process-backdated-transactions/process-backdated-transactions.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;